import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  RaisedButton, Card, CardText, Table, TableHeader, TableBody, TableRow, TableHeaderColumn,
  TableRowColumn,
} from "material-ui";
import DownloadIcon from "material-ui/svg-icons/action/get-app";
import styles from "./../../styles/styles";
import { ShowTecniquesInExcep, UpdateDetailTecniquesForModal } from "../FiltroBusqueda/actions";
import { UpdateDetailTecniques } from '../FiltroBusquedaDetalle/actions';

class ConsultaRecargosDetalle extends React.Component {
  componentWillMount() {
  }

  DownloadRecargosArancel = () => {
    this.props.DownloadRecargosArancel();
  }

  DownloadRecargosFiltrados = () => {
    this.props.DownloadRecargosFiltrados();
  }

  /* 
    * GetValorRecargoExcep : number
    * @params
    * idTipoRecargo: number,
    * tipoAtencion: string
    * @desc
    * Se entrega el ID y tipo de atención para encontrar el valor correspondiente.
   */

  GetValorRecargoExcep = (idTipoRecargo, tipoAtencion) => {
    const recargo = this.props.recargosConvenidosExcep.filter((r) => r.IdTipoRecargo === idTipoRecargo && r.TipoAtencion === tipoAtencion);
    if (recargo && recargo.length === 1) {
      return recargo[0].Valor;
    }
    return "-";
  }

  showTecniques = index => {
    /*
      * @params
      * detailTecniques: object
      * @desc
      * Se genera constante con valores de técnicas
    */
    let detailTecniques = { amb: {}, hosp: {}, };

    this.props.recargosConvenidosExcep.forEach((r, i) => {
      if (i == index) {
        detailTecniques[r.TipoAtencion === 'A' ? 'amb' : 'hosp'] = {
          'Tradicional': r.detailTecniques['Tradicional'] != null ? r.detailTecniques['Tradicional'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Tradicional'] : null,
          'Radiocirugia': r.detailTecniques['Radiocirugia'] != null ? r.detailTecniques['Radiocirugia'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Radiocirugia'] : null,
          'Endoscopia': r.detailTecniques['Endoscopia'] != null ? r.detailTecniques['Endoscopia'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Endoscopia'] : null,
          'Esterotaxica': r.detailTecniques['Esterotaxica'] != null ? r.detailTecniques['Esterotaxica'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Esterotaxica'] : null,
          'Termoterapia': r.detailTecniques['Termoterapia'] != null ? r.detailTecniques['Termoterapia'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Termoterapia'] : null,
          'Microscopica': r.detailTecniques['Microscopica'] != null ? r.detailTecniques['Microscopica'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Microscopica'] : null,
          'Lasik': r.detailTecniques['Lasik'] != null ? r.detailTecniques['Lasik'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Lasik'] : null,
          'Rayo Laser': r.detailTecniques['Rayo Laser'] != null ? r.detailTecniques['Rayo Laser'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Rayo Laser'] : null,
          'Video Laparoscopica': r.detailTecniques['Video Laparoscopica'] != null ? r.detailTecniques['Video Laparoscopica'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Video Laparoscopica'] : null,
          'Endovascular': r.detailTecniques['Endovascular'] != null ? r.detailTecniques['Endovascular'] == '1,0' ? 'No tiene recargo' : r.detailTecniques['Endovascular'] : null,
        };
      }
    });

    //this.props.dispatch(UpdateDetailTecniques(recargosConvenidosExcep));
    this.props.dispatch(UpdateDetailTecniquesForModal(detailTecniques));
    this.props.dispatch(ShowTecniquesInExcep(true));

  }

  render() {
    //console.log("PROPS:", this.props);

    const menuItemsRecargosExcepcionales = [];
    if (this.props.recargosConvenidosExcep && this.props.recargosConvenidosExcep.length > 0) {
      this.props.recargosConvenidosExcep.map((row, index) => (
        menuItemsRecargosExcepcionales.push((
          <TableRow key={index}>
            <TableRowColumn style={styles.contTablaConsultaRecargos1}>{row.TipoAtencion === "A" ? "Ambulatorio" : "Hospitalario"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos2}>{row.CodigoPrestacionIsapre || "-"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos3} title={row.GlosaPrestacionIsapre || "TODAS"}>{row.GlosaPrestacionIsapre || "TODAS"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos2} title={row.GlosaProfesionalIsapre}>{row.GlosaProfesionalIsapre}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos3} title={row.GlosaGrupoPrestacionIsapre}>{row.GlosaGrupoPrestacionIsapre}</TableRowColumn>

            <TableRowColumn style={styles.contTablaConsultaRecargos9}>{row.HorarioHabil || "-"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos9}>{row.HorarioInhabil || "-"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos9}>{row.UrgenciaHabil || "-"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos9}>{row.UrgenciaInhabil || "-"}</TableRowColumn>
            <TableRowColumn style={styles.contTablaConsultaRecargos9}>
              <RaisedButton
                label="Ver"
                onClick={() => this.showTecniques(index)}
                secondary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{ height: 20, width: 45, borderRadius: 5, minWidth: 45 }}
                buttonStyle={{ borderRadius: 5 }}
              />
            </TableRowColumn>
          </TableRow>
        ))
      ));
    }
    return (
      <div >
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0, width: "100%" }}>
              <div style={{ paddingTop: "0px", paddingBottom: "0px", overflow: "auto" }} >
                <div style={{ width: "2000px", overflow: "auto", textAlign: "center" }}>
                  <Table
                    key="tablaConsultaRecargosDetalle"
                    fixedHeader
                    fixedFooter
                    selectable={false}

                  >
                    <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                      <TableRow selectable={false}>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos1} >Tipo Atención</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos2} >Código Prestación</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos3} >Prestación</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos2} >Profesional</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos3} >Tipo de Prestación</TableHeaderColumn>

                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos9} >Horario Hábil</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos9} >Horario Inhábil</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos9} >Urgencia Hábil</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos9} >Urgencia Inhábil</TableHeaderColumn>
                        <TableHeaderColumn style={styles.tituloTablaConsultaRecargos9} >Técnicas</TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody
                      displayRowCheckbox={false}
                      deselectOnClickaway={false}
                      showRowHover
                      stripedRows={false}
                      width={1600}
                    >
                      {menuItemsRecargosExcepcionales}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div className="row" style={{ paddingRight: 20, marginTop: 20, marginBottom: 20 }}>
                <div className="col-12" style={styles.colBotonesActualizar}>

                  <RaisedButton
                    label="Descargar Recargos del Arancel"
                    onClick={this.DownloadRecargosArancel}
                    backgroundColor="#fff"
                    labelPosition="before"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "300px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                    icon={<DownloadIcon />}
                  />
                  <RaisedButton
                    label="Descargar Recargos filtrados"
                    onClick={this.DownloadRecargosFiltrados}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "235px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}

                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

ConsultaRecargosDetalle.propTypes = {
  recargosConvenidosExcep: PropTypes.array.isRequired,
  DownloadRecargosArancel: PropTypes.func.isRequired,
  DownloadRecargosFiltrados: PropTypes.func.isRequired,
  // dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  recargosConvenidosExcep: state.filtroBusquedaRCDetalle.recargosConvenidosExcep,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(ConsultaRecargosDetalle);




// WEBPACK FOOTER //
// ./src/components/RecargosConvenios/ConsultaRecargosDetalle/view.jsx